import { render, staticRenderFns } from "./NsTopnavImageOverlay.vue?vue&type=template&id=49f9b774&scoped=true&"
import script from "./NsTopnavImageOverlay.vue?vue&type=script&lang=js&"
export * from "./NsTopnavImageOverlay.vue?vue&type=script&lang=js&"
import style0 from "./NsTopnavImageOverlay.vue?vue&type=style&index=0&id=49f9b774&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../packages/aem/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49f9b774",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/webcomponents-ui - release-finish/src/main/content/webcomponents/js/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49f9b774')) {
      api.createRecord('49f9b774', component.options)
    } else {
      api.reload('49f9b774', component.options)
    }
    module.hot.accept("./NsTopnavImageOverlay.vue?vue&type=template&id=49f9b774&scoped=true&", function () {
      api.rerender('49f9b774', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/@nuskin/app-components/components/NsTopnavImageOverlay.vue"
export default component.exports